import axiosInstance from '@/utils/axiosInstance.js'
import SERVICES from '@/utils/servicesUtil.js'

const updatePassword = ($form) => axiosInstance.post(`${SERVICES.USER}/change-password`, $form)
const sendTokenToChangeEmail = (userID, body) => axiosInstance.patch(`${SERVICES.USER}/${userID}/email`, body)
const updateUserEmail = (userID, body) => axiosInstance.post(`${SERVICES.USER}/${userID}/email/confirm`, body)
const sendTokenToChangePhone = (userID, body) => axiosInstance.patch(`${SERVICES.USER}/${userID}/phone`, body)
const updateUserPhone = (userID, body) => axiosInstance.post(`${SERVICES.USER}/${userID}/phone/confirm`, body)
const disableUser = (userID) => axiosInstance.patch(`${SERVICES.USER}/${userID}/disable`)

export default {
  sendTokenToChangeEmail,
  updateUserEmail,
  sendTokenToChangePhone,
  updateUserPhone,
  disableUser,
  updatePassword
}
